import React from 'react';

const NebulaPerformanceLogFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaPerformanceLogModalRegistry = {
    personalize_nebulaPerformanceLogId: NebulaPerformanceLogFormModal
};
export default nebulaPerformanceLogModalRegistry;
